import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { loginOtpSend, loginOtpVerify } from "../../services/partnerNetworkApi";
import { startStudioSession } from "./PartnerInvitePage";
import "./partner-link.scss";

/** Phone-OTP sign-in for partners whose workspace a designer sponsors (they have no password). */
const PartnerLoginPage = () => {
  const history = useHistory();
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [sent, setSent] = useState(false);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  return (
    <main className="plink plink--center">
      <div className="plink__brand">HKP</div>
      <h1 className="plink__title">Partner sign-in</h1>
      <section className="plink__card plink__form">
        <label>
          Mobile number
          <input inputMode="tel" autoComplete="tel" value={phone} onChange={(e) => setPhone(e.target.value)} />
        </label>
        {sent ? (
          <label>
            Code
            <input inputMode="numeric" autoComplete="one-time-code" maxLength={4} value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))} />
          </label>
        ) : null}
        {message ? <p className="plink__spec" role="status">{message}</p> : null}
        <button className="plink__btn plink__btn--primary" disabled={busy || phone.replace(/\D/g, "").length < 10 || (sent && otp.length !== 4)}
          onClick={async () => {
            setBusy(true);
            if (!sent) {
              const res = await loginOtpSend(phone);
              setSent(res.success);
              setMessage(res.message || "");
            } else {
              const res = await loginOtpVerify(phone, otp);
              if (res.success && res.data?.token) {
                startStudioSession(res.data);
                history.replace("/partner-network/incoming");
              } else {
                setMessage(res.message || "That code is wrong or has expired.");
              }
            }
            setBusy(false);
          }}>
          {sent ? "Sign in" : "Send code"}
        </button>
      </section>
    </main>
  );
};

export default PartnerLoginPage;
